import { render, staticRenderFns } from "./PracticalExamParticipants.vue?vue&type=template&id=3d324e07&"
import script from "./PracticalExamParticipants.vue?vue&type=script&lang=ts&"
export * from "./PracticalExamParticipants.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports